import axios from 'axios';
export default {
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}
